export default {
  haveAccount: 'Already have an account?',
  linkAccount: 'Sign Up or Link Account',
  getShippingLabel: 'Get Shipping Label',
  connectingToPacklink: 'Connecting to Packlink...',
  signIn: 'Sign In',
  needAccount: "Don't have an account yet?",
  signUp: 'Sign Up',
  editShippingLabel: 'Edit Shipping Label',
  login: {
    header: 'Login to Packlink Pro',
    email: 'Email',
    password: 'Password',
    submit: 'Login',
    countryCode: 'Country',
    countryCodes: {
      BE: 'Belgium',
      DE: 'Germany',
      ES: 'Spain',
      FR: 'France',
      IE: 'Ireland',
      IT: 'Italy',
      NL: 'Netherlands',
      PT: 'Portugal',
      UN: 'Unspecified',
    },
  },
  account: {
    failed: 'Linking to Packlink account failed.',
  },
  register: {
    header: 'Sign Up for Packlink Pro',
    email: 'Email',
    password: 'Password',
    passwordTip: '(at least {{minLength}} characters)',
    submit: 'Create Packlink Account',
    dataProcessing: 'I agree to allow Packlink to store and process my data',
    marketingCalls: 'Receive Packlink commercial calls',
    marketingEmails: 'Receive Packlink promotional e-mails',
    termsAndConditions: "I accept Packlink's {{termsLinkOpen}}Terms & Conditions{{termsLinkClose}} and {{privacyLinkOpen}}Privacy Policy{{privacyLinkClose}}",
  },
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/packlink/en.js